<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="preview-container text-center my-3">
            <img :src="data.image.path" alt="Advertisement Image" />
          </div>
          <!-- Start:: Provider Input -->
          <base-select-input
            col="6"
            :optionsList="providers"
            :placeholder="$t('SIDENAV.providers.name')"
            v-model="data.provider_name"
            disabled
          />
          <!-- End:: Provider Input -->
           <!-- Start:: Additions Input -->
          <base-select-input
            col="6"
            :optionsList="additions"
            :placeholder="$t('PLACEHOLDERS.additions')"
            v-model="data.additions"
            multiple
            disabled
          />
          <!-- End:: Additions Input -->
           <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codenameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- Start:: Description Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProd')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descProdEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <!-- End:: Description Input -->
           <!-- Start:: Category Input -->
          <base-select-input
            col="12"
            :optionsList="categories"
            :placeholder="$t('PLACEHOLDERS.category')"
            v-model="data.category"
            disabled
          />
          <!-- End:: Category Input -->
          <!-- Start:: Sizes and Prices Input -->
          <div class="col-12">
            <div
              v-for="(size, index) in data.sizes"
              :key="index"
              class="row align-items-center"
            >
              <base-select-input
                col="6"
                :placeholder="$t('PLACEHOLDERS.size')"
                v-model="size.size"
                :optionsList="sizes"
                :track-by="'id'"
                :label="'name'"
                disabled
              />
              <base-input
                col="6"
                type="number"
                :placeholder="$t('PLACEHOLDERS.price')"
                v-model="size.price"
                disabled
              />
            </div>
          </div>
          <!-- End:: Sizes and Prices Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->
          <!-- Start:: Additional Images -->
          <h5 v-if="imgUrls.length > 0" style="color: #266db0;">{{ $t("PLACEHOLDERS.productImgs") }}</h5>
          <div class="preview-container text-center my-3">
            <img v-for="image in imgUrls" :src="image" alt="Advertisement Image" class="mx-2 mb-5"/>
          </div>
          <!-- End:: Additional Images -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "ShowProduct",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",
      additionalFiles: [],
      additionalImages: [],
      imgUrls: [],

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        provider_name: null,
        category: null,
        sizes: [{ size: null, price: null }],
        additions: [],
        active: true,
        publish_start_date: null,
        publish_end_date: null,
      },
      // End:: Data Collection To Send
      providers: [],
      categories: [],
      sizes: [],
      additions: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `products/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.Product.file_path;
        this.data.name = res.data.data.Product.name_ar;
        this.data.nameEn = res.data.data.Product.name_en;
        this.data.descProd = res.data.data.Product.description_ar;
        this.data.descProdEn = res.data.data.Product.description_en;
        this.data.provider_name = res.data.data.Product.user;
        this.data.category = res.data.data.Product.category;
        this.data.sizes = res.data.data.Product.sizes.map(size => ({ size:{id: size.id, name: size.name, value: size.name}, price: size.price }));
        this.data.additions = res.data.data.Product.additions;
        this.data.active = res.data.data.Product.is_active === 1;
        this.imgUrls = res.data.data.Product.files_paths.map(file => file.image);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    // End:: Fire Methods
  },
};
</script>
